import { render } from "./BuilderEstimatorHouseUpgradeOption.vue?vue&type=template&id=40541372&scoped=true&ts=true&lang=pug"
import script from "./BuilderEstimatorHouseUpgradeOption.vue?vue&type=script&setup=true&lang=ts"
export * from "./BuilderEstimatorHouseUpgradeOption.vue?vue&type=script&setup=true&lang=ts"

import "./BuilderEstimatorHouseUpgradeOption.vue?vue&type=style&index=0&id=40541372&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40541372"]])

export default __exports__